import ArrowLeftOutlined from '@ant-design/icons/ArrowLeftOutlined';
import TeamOutlined from '@ant-design/icons/TeamOutlined';
import TagsOutlined from '@ant-design/icons/TagsOutlined';
import CloudUploadOutlined from '@ant-design/icons/CloudUploadOutlined';

const cadastros = {
  id: 'group-cadastros',
  title: 'Cadastros',
  type: 'group',
  children: [
    {
      id: 'back-to-core',
      title: 'Voltar ao Principal',
      type: 'item',
      url: '/dashboard',
      icon: ArrowLeftOutlined,
      breadcrumbs: false
    },
    {
      id: 'pessoas',
      title: 'Pessoas',
      type: 'item',
      url: '/cadastros/pessoas',
      icon: TeamOutlined,
      permissions: ['cadastros.pessoas.view'],
      breadcrumbs: false
    },
    {
      id: 'catalogos',
      title: 'Catálogos',
      type: 'item',
      url: '/cadastros/catalogos',
      icon: TagsOutlined,
      permissions: ['cadastros.catalogos.manage'],
      breadcrumbs: false
    },
    {
      id: 'importacao',
      title: 'Importação',
      type: 'item',
      url: '/cadastros/importacao',
      icon: CloudUploadOutlined,
      permissions: ['cadastros.pessoas.create'],
      breadcrumbs: false
    }
  ]
};

export default cadastros;
